<template>
    <div>
        <el-row class="aggregate-row" type="flex" align="middle">
            <el-button type="primary" @click="getCsv" :disabled="hasNoData">CSV出力</el-button>
            <el-radio-group v-model="aggregate" @change="changeAggregate" :disabled="disabled">
                <el-radio label="sum">期間合計</el-radio>
                <el-radio label="avg">期間平均</el-radio>
            </el-radio-group>
        </el-row>
        <div id="slc"></div>
    </div>
</template>

<script>
import Plotly from 'plotly.js-basic-dist'

export default {
    name: 'Plot',
    props: {
        disabled: Boolean
    },
    data() {
        return {
            aggregate: "sum",
            plotData: []
        }
    },

    computed: {
        attribute: function () {
            return this.$store.getters.attribute
        },
        data: function () {
            return this.$store.getters.data
        },
        dateCount: function () {
            return this.$store.getters.dateCount
        },
        hasTodayCount: function () {
            return this.$store.getters.hasTodayCount
        },
        hasNoData: function () {
            if (this.plotData.length < 1) {
                return true
            } else {
                return false
            }
        }
    },

    watch: {
        data() {
            let dataList = this.data

            if (this.attribute == "age") {
                this.plotData = [
                    { label: "~10代 ", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: " 20代 ", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: " 30代 ", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: " 40代 ", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: " 50代 ", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: " 60代~", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] }
                ]

                dataList.forEach((d) => {
                    let index = 0
                    switch (d.attribute) {
                        case "10":
                            index = 0
                            break;
                        case "20":
                            index = 1
                            break;
                        case "30":
                            index = 2
                            break;
                        case "40":
                            index = 3
                            break;
                        case "50":
                            index = 4
                            break;
                        case "60":
                            index = 5
                            break;
                    }
                    for (let i = 0; i < 24; i++) {
                        this.plotData[index].data[i] += d.counts[i]
                    }
                })
            } else {
                this.plotData = [
                    { label: "男性", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                    { label: "女性", data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
                ]

                dataList.forEach((d) => {
                    let index = 0
                    switch (d.attribute) {
                        case "male":
                            index = 0
                            break;
                        case "female":
                            index = 1
                            break;
                    }
                    for (let i = 0; i < 24; i++) {
                        this.plotData[index].data[i] += d.counts[i]
                    }
                })

            }

            this.plot(this.aggregate, this.plotData)

        }
    },

    methods: {
        getAverage: function (val, index) {
            let cnt = this.dateCount
            let now = new Date().getHours()

            // まだ到達していない時刻は、当日分を除いた平均を計算する
            if (this.hasTodayCount && index > now) {
                cnt -= 1
            }

            return Math.round((val / cnt) * 100) / 100
        },

        plot: function (aggregate, source) {
            let traces = []
            let colorway = ["rgb(12, 89, 133)",
                "rgb(26, 128, 169)",
                "rgb(93, 184, 198)",
                "rgb(192, 230, 224)",
                "rgb(115, 193, 185)",
                "rgb(67, 173, 173)"]

            source.forEach((element, index) => {

                // 平均の時はデータを日数で割り、小数第3位で四捨五入
                let y_data = element.data
                if (aggregate == "avg" && this.dateCount > 1) {
                    y_data = y_data.map(this.getAverage)
                }

                let trace = {
                    x: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
                    y: y_data,
                    name: element.label,
                    marker: {
                        color: colorway[index]
                    },
                    hovertemplate: "<b>" + element.label + "</b><br>%{y:.f}人<extra></extra>",
                    type: 'bar',
                }
                traces.push(trace)
            })

            const layout = {
                hovermode: 'closest',
                title: "",
                barmode: 'stack',
                xaxis: {
                    dtick: 1,
                    zeroline: false,
                    range: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"],
                },
                yaxis: {
                    title: '人数',
                    overlaying: 'y2',
                    tickformat: ".f",
                    rangemode: "nonnegative"
                    // range:[0, range_max]
                },
            };

            const config = {
                responsive: true,
                displaylogo: false,
                modeBarButtonsToRemove: ["zoom2d", "pan2d", "select2d", "lasso2d", "zoomIn2d", "zoomOut2d", "autoScale2d", "toggleSpikelines"],
                toImageButtonOptions: {
                    format: 'svg',
                    filename: 'count',
                    scale: 1
                },
            }

            Plotly.newPlot('slc', traces, layout, config)
        },

        getCsv: function () {
            let output = "\"属性\",\"0時\",\"1時\",\"2時\",\"3時\",\"4時\",\"5時\",\"6時\",\"7時\",\"8時\",\"9時\",\"10時\",\"11時\",\"12時\",\"13時\",\"14時\",\"15時\",\"16時\",\"17時\",\"18時\",\"19時\",\"20時\",\"21時\",\"22時\",\"23時\"\n"

            this.plotData.forEach((d) => {
                let row = "\"" + d.label + "\","
                let counts = d.data
                if (this.aggregate == "avg" && this.dateCount > 1) {
                    counts = counts.map(this.getAverage)
                }
                output += row + counts.join(",") + "\n"
            })

            const filename = `${this.attribute}_${this.aggregate}_${this.getDateRange()}.csv`;
            const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
            const blob = new Blob([bom, output], { type: "text/csv" });

            //IE10/11用(download属性が機能しないためmsSaveBlobを使用）
            if (window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, filename);
                //その他ブラウザ
            } else {
                const url = (window.URL || window.webkitURL).createObjectURL(blob);
                const download = document.createElement("a");
                download.href = url;
                download.download = filename;
                download.click();
                (window.URL || window.webkitURL).revokeObjectURL(url);
            }

        },

        formatDateString: function(date) {
            return date.replaceAll('-', '');
        },

        getDateRange: function() {
            if(this.$store.state.dateCount === 1){
                return this.formatDateString(this.data[0]["date"])
            } else {
                const sorted = this.data.sort((a, b)=>{
                    return new Date(a["date"]).getTime() - new Date(b["date"]).getTime()
                })
                console.log(sorted)
                return `${this.formatDateString(sorted[0]["date"])}-${this.formatDateString(sorted[sorted.length -1]["date"])}`
            }
        },

        changeAggregate: function (aggregate) {
            this.plot(aggregate, this.plotData)
        }
    },

    mounted() {
        this.plot("年齢別", this.plotData)
    }
}
</script>

<style scoped>
.el-button {
    margin-right: 20px;
}
</style>